import o from "./_Symbol.js";
var e = o ? o.prototype : void 0, l = e ? e.valueOf : void 0;
function r(t) {
  return l ? Object(l.call(t)) : {};
}
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_cloneSymbol.js
// module id = 1500
// module chunks = 67